<template>
    <div class="main-content">
        <div class="page-header">
            <h3 class="page-title">Ver compra</h3>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a href="#">Compra</a>
                </li>
                <li class="breadcrumb-item active">Ver combra</li>
            </ol>
        </div>
        <div class="card" v-if="LoadingView===false">
            <div class="card-header" :class="purchase.state===2?'bg-warning':purchase.state===1?'bg-success':'bg-danger'">
                <h5>Compra: {{document}}</h5>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-3">
                            <label class="font-weight-bold">Fecha</label>
                            <p>{{convertDate(purchase.purchase_date)}}</p>
                        </div>
                        <div class="col-md-3">
                            <label class="font-weight-bold">Fecha de entrega</label>
                            <p>{{convertDate(purchase.delivery_date)}}</p>
                        </div>
                        <div class="col-md-3">
                            <label class="font-weight-bold">Localidad</label>
                            <p>{{place.name}}</p>
                        </div>
                        <div class="col-md-3">
                            <label class="font-weight-bold">Proveedor</label>
                            <p>{{provider.nit}} | {{provider.company}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <label class="font-weight-bold">Comprador</label>
                            <p>{{buyer.name}}</p>
                        </div>
                        <!-- <div class="col-md-3">
                            <label class="font-weight-bold">Cajero</label>
                            <p v-if="sale.state==1">{{chequer.name}}</p>
                            <p v-else>Venta aun no cobrada</p>
                        </div> -->
                        <div class="col-md-3">
                            <label class="font-weight-bold">Estado</label>
                            <br>
                            <template>
                                <span class="btn btn-danger btn-sm" v-if="purchase.state===0">Anulado</span>
                                <span class="btn btn-warning btn-sm" v-if="purchase.state===2">Pendiente</span>
                                <span class="btn btn-success btn-sm" v-if="purchase.state===1">Comprobado</span>
                            </template>
                        </div>
                    </div>
                    <div class="row">
                        <div class="card-body">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Producto</th>
                                        <th>Precio</th>
                                        <th>Cantidad</th>
                                        <th>Descuento</th>
                                        <th>Subtotal</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in purchases" :key="item.id">
                                        <td>{{item.code}}</td>
                                        <td>{{item.nameProduct}}</td>
                                        <td>{{mymoney(item.purchase_price)}}</td>
                                        <td>{{myquantity(item.amount)}}</td>
                                        <td>{{mymoney(calculateSubtotal(item.purchase_price,item.amount))}}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colspan="5" class="text-right">
                                            <h6 class="font-weight-bold">Total</h6>
                                        </th>
                                        <th>
                                            <h6 class="font-weight-bold">{{mymoney(purchase.total)}}</h6>
                                        </th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" v-if="LoadingView===false">
            <div class="card-header bg-primary">
                <h5>Pagos</h5>
            </div>
            <div class="card-body">
                <div class="row" v-for="payment in payments" :key="payment.id">
                    <template v-if="payment.namePayment==='Efectivo'">
                        <div class="container">
                            <div class="row justify-content-center">
                                <h5 class="font-weight-bold">{{payment.namePayment}}</h5>
                            </div>
                        </div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <td>Monto</td>
                                    <td>Cuenta</td>
                                    <td>Descripción</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{mymoney(payment.amount)}}</td>
                                    <td>{{payment.nameAccount}}</td>
                                    <td>{{payment.description}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-if="payment.namePayment==='Cheque'">
                        <div class="container">
                            <div class="row justify-content-center">
                                <h5 class="font-weight-bold">{{payment.namePayment}}</h5>
                            </div>
                        </div>
                        <table class="table table-dark">
                            <thead>
                                <tr>
                                    <td>Monto</td>
                                    <td>Cuenta</td>
                                    <td>No.Cheque</td>
                                    <td>Banco</td>
                                    <td>Mismo banco</td>
                                    <td>Descripción</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{mymoney(payment.amount)}}</td>
                                    <td>{{payment.nameAccount}}</td>
                                    <td>{{payment.ChequeNumber}}</td>
                                    <td>{{payment.ChequeNameBank}}</td>
                                    <td>
                                        <template>
                                            <span class="btn btn-danger btn-sm" v-if="payment.ChequeSameBank==='0'">No</span>
                                            <span class="btn btn-success btn-sm" v-if="payment.ChequeSameBank==='1'">Si</span>
                                        </template>
                                    </td>
                                    <td>{{payment.description}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-if="payment.namePayment==='Depósito'">
                        <div class="container">
                            <div class="row justify-content-center">
                                <h5 class="font-weight-bold">{{payment.namePayment}}</h5>
                            </div>
                        </div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <td>Monto</td>
                                    <td>Cuenta</td>
                                    <td>No.Depósito</td>
                                    <td>Descripción</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{mymoney(payment.amount)}}</td>
                                    <td>{{payment.nameAccount}}</td>
                                    <td>{{payment.DepositNumber}}</td>
                                    <td>{{payment.description}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-if="payment.namePayment==='Tarjeta de Crédito/Debito'">
                        <div class="container">
                            <div class="row justify-content-center">
                                <h5 class="font-weight-bold">{{payment.namePayment}}</h5>
                            </div>
                        </div>
                        <table class="table table-dark">
                            <thead>
                                <tr>
                                    <td>Monto</td>
                                    <td>Cuenta</td>
                                    <td>No.Transacción</td>
                                    <td>Nombre de tarjeta</td>
                                    <td>Ultimos 4 dígitos de la tarjeta</td>
                                    <td>Descripción</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{mymoney(payment.amount)}}</td>
                                    <td>{{payment.nameAccount}}</td>
                                    <td>{{payment.CardNumber}}</td>
                                    <td>{{payment.CardName}}</td>
                                    <td>{{payment.CardLast4digits}}</td>
                                    <td>{{payment.description}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-if="payment.namePayment==='Transferencia'">
                        <div class="container">
                            <div class="row justify-content-center">
                                <h5 class="font-weight-bold">{{payment.namePayment}}</h5>
                            </div>
                        </div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <td>Monto</td>
                                    <td>Cuenta</td>
                                    <td>No.Transferencia</td>
                                    <td>Banco</td>
                                    <td>Mismo banco</td>
                                    <td>Descripción</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{mymoney(payment.amount)}}</td>
                                    <td>{{payment.nameAccount}}</td>
                                    <td>{{payment.TransferNumber}}</td>
                                    <td>{{payment.TransferNameBank}}</td>
                                    <td>
                                        <template>
                                            <span class="btn btn-danger btn-sm" v-if="payment.TransferSameBank==='0'">No</span>
                                            <span class="btn btn-success btn-sm" v-if="payment.TransferSameBank==='1'">Si</span>
                                        </template>
                                    </td>
                                    <td>{{payment.description}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </div>
            </div>
        </div>
        <div class="spinner-border" role="status" v-if="LoadingView===true">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>
<script>
    import { xelacode } from '../../../helpers/xelacode'
    export default {
        data() {
            return {
                purchase: {},
                document: {},
                LoadingView: true,
                place: {},
                buyer: {},
                provider: {},
                purchases: [],
                payments:[],
            }
        },
        methods: {
            myquantity(value) {
                return xelacode.quantity(value);
            },
            mymoney(value) {
                return xelacode.money(parseFloat(value));
            },
            getPurchase() {
                let vm = this;
                var url = `/api/purchase/show/${this.$route.query.id}`;
                vm.LoadingView = true;
                axios.get(url)
                    .then(function (response) {
                        vm.purchase = response.data.purchase;
                        vm.document = response.data.document;
                        vm.place = response.data.place;
                        vm.provider = response.data.provider;
                        vm.buyer = response.data.buyer;
                        vm.purchases = response.data.purchases;
                        vm.payments=response.data.payments;
                        // vm.getNameBank();
                        vm.LoadingView = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        vm.LoadingView = false;
                    });
            },
            convertDate(date) {
                var newDate = date.split('-');
                return newDate[2] + '/' + newDate[1] + '/' + newDate[0];
            },
            parseDecimal(value) {
                return parseFloat(this.parseDecimalFixed(value));
            },
            parseDecimalFixed(value) {
                return parseFloat(value).toFixed(2);
            },
            calculateSubtotal(price, quantity, discount) {
                return (this.parseDecimal(price) * this.parseDecimal(quantity));
            },
            // getNameBank(){
            //     let vm=this;
            //     vm.payments.forEach((element,index) => {
            //         if(element.namePayment==="Cheque")
            //         {
            //             axios.get(`/api/sale/getNameBank/${element.ChequeNameBank}`)
            //             .then((response)=>{
            //                 vm.payments[index].ChequeNameBank=response.data.nameBank;
            //             }).catch((error)=>{
            //                 console.log(error)
            //             })    
            //         }else if(element.namePayment==="Transferencia"){
            //             axios.get(`/api/sale/getNameBank/${element.TransferNameBank}`)
            //             .then((response)=>{
            //                 vm.payments[index].TransferNameBank=response.data.nameBank;
            //             }).catch((error)=>{
            //                 console.log(error)
            //             })
            //         }
            //     });
            // }
        },
        mounted() {
            this.getPurchase();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/admin/purchase/ViewPurchase.vue